import { createContext, createEffect, useContext } from 'solid-js';
import { ViewContext } from './ViewContext';
import { view as api } from 'st-app/api';
import { ActionArea } from './fragments/ActionArea';
const ST = (window as any).ST || {};

export const ViewContextJSX = createContext<ViewContext>();

export function requireViewContext(): ViewContext {
    const res = useContext(ViewContextJSX);
    if (res) return res;

    throw new Error("Missing view context.");
}

export function useViewContext(): ViewContext | undefined {
    return useContext(ViewContextJSX);
}

export class STViewProps {
    viewId?: string = undefined;
    tabId?: string = undefined;
    identity?: string = undefined;
}

export default function STView(params: STViewProps) {
    const viewContext = new ViewContext();

    createEffect(() => {
        viewContext.setViewId(params.viewId || '');
        viewContext.setTabId(params.tabId || '');
    });

    return <ViewContextJSX.Provider value={viewContext}>
        <STViewInternal />
        Test: I am a view (viewId: {params.viewId}, identity: {params.identity})
    </ViewContextJSX.Provider>;
}

function STViewInternal() {
    const viewContext = requireViewContext();

    return (
        <div>
            <h1>
                {viewContext.definition?.title}
            </h1>
            <ActionArea />
            {/* Test: I am a view (viewId: {params.viewId}, identity: {params.identity}) */}
        </div>
    );
}

STView.defaultProps = new STViewProps();

async function init(viewId : string) {
    const res = await api.GetViewDef(viewId);
    const viewDefinition = await api.LoadViewDefinition(viewId);

    console.log({ viewDefinition });

    if (ST.DEBUGGING_COMPONENT) {
        console.log(res);
    }
}

type ViewType = 'VIEW'

export function loadView(
    type: ViewType,
    id: string,
    detached = false,
    noRemember = false,
    includeState = false,
    includeViewNode = false,
    focusKey: string | undefined = undefined,
    extendData: Record<string, any> | undefined = undefined,
) {
    if (ST.LoadView) {
        ST.LoadView(type, id, detached, noRemember, includeState, includeViewNode, focusKey, extendData);
        return
    }

    if (detached) {
        window.open(`/views/${id}`, undefined, 'popup=true');
    }
}

export function openViewWindow(
    viewGU: string,
    tabGU: string | undefined = undefined,
    identity: string | undefined = undefined,
    extraParams: Record<string, any> | undefined = undefined,
) {
    if (ST.OpenViewWindow) {
        ST.OpenViewWindow(viewGU, tabGU, identity, extraParams);
        return;
    }

    alert(`Open view ${viewGU} in window`);
}


export async function openViewInDialog(viewID: string, identity: string | undefined = undefined, options?: OpenViewOptions): Promise<void> {
    if (ST.OpenViewInDialog) {
        const extra = {
            REV_RENDER: {
                VIEW: {
                    '@MODE': options?.mode ?? 'NORMAL',
                }
            }
        };

        return ST.OpenViewInDialog(viewID, identity, extra);
    }

    alert(`Open view ${viewID} in dialog`);
}


interface OpenViewOptions {
    mode?: ViewMode
}

type ViewMode = 'NORMAL' | 'ADD' | 'DETAIL' | 'FIND_RESULT' | 'FK_SELECT' | 'EXT_OBJ_SELECT' | 'DIALOG' | 'CHOOSER' | 'JOB_Q_EXECUTE' | 'QUERY';